import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Card, Table } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import { CSVLink } from "react-csv"
import moment from 'moment'
import SpinningLoader from './SpinningLoader'
type Props = {
    data?: any,
    cardTitle?: string,
    setFilterData?: (s: string) => void,
    setFromDate?: (a: string | number | Date) => void,
    fromDate?: string | number | Date,
    setToDate?: (a: string | number | Date) => void,
    toDate?: string | number | Date,
    filterData?: string,
    pageNumber?: number,
    limit?: number,
    setSearchResult?: (s: string) => void,
    setPageNumber?: (s: number) => void,
    setDateToggle?: (b: boolean) => void,
    dateToggle?: boolean,
    exportDisabled?: boolean,
}
const MRDetailsCard = ({ data, setDateToggle = (b: boolean) => false, dateToggle, setSearchResult = (s: string) => "", limit = 8, pageNumber = 1, setPageNumber = (s: number) => 1, cardTitle, setFilterData = (s: string) => "", filterData, setFromDate = (a: string | number | Date) => "", setToDate = (a: string | number | Date) => "", fromDate, toDate, exportDisabled }: Props) => {

    const [selectData, setSelectData] = useState<any[]>([])
    console.log("exportDisabled", exportDisabled)
    useEffect(() => {
        getZoneList()
    }, [])

    const getZoneList = () => {
        const getMRObj = {
            method: "get_zone_list",
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}get_zone_list`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setSelectData(response?.data.sort((a: any, b: any) =>
                            a.zone_name.localeCompare(b.zone_name)));
                    }
                });
            })
    };

    // const que = new Map();
    // que.set(`que`, item?.content && JSON.parse(item?.content)?.questions);

    const arr = data?.map((item: any, index: number) => {        
        return (
            {
                "id": index + 1,
                "Created At": item?.content && JSON.parse(item?.content)?.date,
                "Zone Name": item?.zone_name,
                "MR name": item?.mr_name,
                "Doctor Name": item?.content && JSON.parse(item?.content)?.doctor_name,
                "Doctor City": item?.content && JSON.parse(item?.content)?.doctor_city,
                "Q-1": item?.content && JSON.parse(item?.content)?.questions[0]?.ans,
                "Q-2": item?.content && JSON.parse(item?.content)?.questions[1]?.ans,
                "Q-3": item?.content && JSON.parse(item?.content)?.questions[2]?.ans,
                "Q-4": item?.content && JSON.parse(item?.content)?.questions[3]?.ans,
                "Q-5": item?.content && JSON.parse(item?.content)?.questions[4]?.ans,
                "Q-6": item?.content && JSON.parse(item?.content)?.questions[5]?.ans,
            }
        )
    })

    const applyDate = () => {
        setDateToggle(!dateToggle)
        setPageNumber(1)
    }

    const clearDate = () => {
        setFromDate('')
        setToDate('')
        setPageNumber(1)
        setDateToggle(!dateToggle)
    }
    return (
        <>
            <Card style={{ borderRadius: '0px' }} >
                <Card.Body style={{ backgroundColor: "#FBFBFB" }} >
                    <Card.Text>
                        <div className='d-flex align-items-center justify-content-between flex-wrap' >
                            <input className='search-input'
                                onChange={(e) => { setSearchResult(e?.target?.value); setPageNumber(1) }}
                                placeholder=' search '
                                style={{ outline: 'none', width: '300px', borderRadius: '8px', border: 'solid #D4D7ED 1px', fontSize: '16px', padding: '8px' }} />
                            <div className='d-flex align-items-center'>
                                <DatePicker
                                    className="p-inp"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="From Date"
                                    selected={fromDate as Date}
                                    onChange={(d) => {
                                        d && setFromDate(d);
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                />
                                <DatePicker
                                    className="p-inp mx-2"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="To Date"
                                    selected={toDate as Date}
                                    onChange={(d) => {
                                        d && setToDate(d);
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                />
                                <button disabled={toDate === "" && fromDate === ""} onClick={() => clearDate()} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }} >Clear</button>
                                <button className='mx-2' disabled={toDate === "" && fromDate === ""} onClick={() => applyDate()} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }} >Apply</button>
                            </div>
                            {!cardTitle && <select
                                className='form-select-solid w-100px w-xxl-125px p-3'
                                data-control='select2'
                                data-placeholder='Filter by zone'
                                data-hide-search='true'
                                defaultValue={filterData}
                                onChange={(e) => { setFilterData(e?.target?.value); setPageNumber(1) }}
                                style={{ border: 'solid #D4D7ED 1px', borderRadius: '8px', outline: 'none' }}
                            >
                                <option value='' hidden >Filter by zone</option>
                                <option value='' >All</option>
                                {
                                    selectData?.map((item: any, index: number) => {
                                        return (
                                            <option key={index} value={`${item?.id}`}>{item?.zone_name}</option>
                                        )
                                    })
                                }
                            </select>}

                            {(!cardTitle && exportDisabled) ? <CSVLink data={arr} filename={'submissionData'} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }} >Export Data</CSVLink> : <div style={{ width: '108px', borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }}> <SpinningLoader isLoading={!exportDisabled} /> </div>}
                        </div>

                    </Card.Text>
                </Card.Body>
                {
                    window.location.pathname !== "/admin/data" &&
                    <Card.Body>
                        <Card.Text>
                            <div className='d-flex justify-content-between flex-wrap' >
                                <div className='d-flex justify-content-between flex-wrap '>
                                    <div style={{ borderRadius: '100%', width: '100px', height: '100px' }} >
                                        <img src="./image/dp.jpg" alt="img" style={{ objectFit: 'fill' }} />
                                    </div>
                                    <div className='d-flex flex-column justify-content-center' >
                                        <span style={{ marginLeft: '20px', color: '#5B5B5B', fontFamily: 'Poppins', fontSize: '2rem', fontWeight: '600' }}>Jagdish Sharma</span>
                                        <span style={{ marginLeft: '20px', color: '#15B8CB', fontFamily: 'Poppins', fontSize: '1.6rem', fontWeight: '600' }}>Zone : Saurashtra</span>
                                    </div>
                                </div>
                                <div className='d-flex flex-column justify-content-center text-end ' >
                                    <span style={{ color: '#5B5B5B', fontSize: '1.3rem' }} >Total Submission Count :</span>
                                    <span style={{ color: '#0071BB', fontSize: '2.5rem', fontWeight: '600' }} >812</span>
                                </div>
                            </div>
                        </Card.Text>
                    </Card.Body>
                }
            </Card>
        </>
    )
}

export default MRDetailsCard
